import React from 'react';
export function Footer() {
  return <footer className="w-full bg-canvas px-4 py-10 text-center sm:px-6" data-id="element-53" data-mp="32wd2qgad7ltj">
      <p className="mx-auto max-w-2xl text-xs leading-relaxed text-gray-500" data-id="element-54" data-mp="3ggaqfufcyb4x">
        Este contenido es educativo y no sustituye el diagnóstico, tratamiento
        ni acompañamiento de un profesional de la salud. Si tienes una condición
        médica, estás embarazada, lactando o tomas medicamentos, consulta con tu
        médico antes de realizar cambios importantes en tu alimentación o estilo
        de vida.
      </p>
      <p className="mt-4 font-display text-xs font-extrabold uppercase tracking-wider text-brand-deep" data-id="element-55" data-mp="37xx4ku5y8k4">
        Metabolismo Restart · Todos los derechos reservados
      </p>
    </footer>;
}